// src/utils/axiosInstance.js

import axios from 'axios';
import { toast } from 'react-toastify';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isLoggingOut = false;

const handleTokenExpiration = (message) => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  toast.error(message || 'Token expired logging you out');
  localStorage.clear();
  setTimeout(() => {
    window.location.href = '/auth/login';
  }, 1000);
};

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('loginToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      response.data.status === false &&
      (response.data.code === 401 ||
        response.data.message === 'The token is invalid' ||
        (typeof response.data.message === 'string' &&
          response.data.message.toLowerCase().includes('token')))
    ) {
      handleTokenExpiration(response.data.message || 'Token expired logging you out');
      return Promise.reject(new Error(response.data.message || 'Token is invalid'));
    }
    return response;
  },
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 ||
        error.response.data?.code === 401 ||
        error.response.data?.message === 'The token is invalid' ||
        (typeof error.response.data?.message === 'string' &&
          error.response.data.message.toLowerCase().includes('token')))
    ) {
      const msg = error.response.data?.message || 'Token expired logging you out';
      handleTokenExpiration(msg);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
